import React, { useEffect } from 'react'

import { useSelector } from 'react-redux'

import { BottomSheet } from '@interco/inter-ui/components/BottomSheet'
import { Button } from '@interco/inter-ui/components/Button'
import { ColorWrapper, TextParagraph } from '@atoms'
import { Colors } from '@utils/Colors'
import { BridgeService } from '@services/bridge'
import Tag from '@utils/Tag'
import { ApplicationState } from '@store/types'

interface Props {
  setShowBottomSheetRefazerBiometria: React.Dispatch<React.SetStateAction<boolean>>
  redirectBiometria: () => void
}

export const BottomSheetRefazerBiometria = ({
  setShowBottomSheetRefazerBiometria,
  redirectBiometria,
}: Props) => {
  const { convenioName } = useSelector((state: ApplicationState) => state.refinanciamento.contratos)
  const { isApp } = useSelector((state: ApplicationState) => state.ui.navigation)

  useEffect(() => {
    BridgeService.tac({
      name: 'bottomsheet_refazer_biometria',
      actions: ['abrir_bottomsheet_refazer_biometria'],
    })

    if (isApp) {
      Tag.enviarTagueamentoApp({
        ref_figma: '2',
        name: '',
        screen: 'Bottomsheet Refazer Biometria',
        ref_type: '',
        content_action: 'Abrir',
        content_name: 'Biometria não validada',
        product: convenioName,

        product_area: 'refin',
      })
    }
  }, [convenioName, isApp])

  const handleClose = () => {
    BridgeService.tic({
      name: 'btn_fechar_refazer_biometria',
      action: 'fechar_bottomsheet_refazer_biometria',
    })

    if (isApp) {
      Tag.enviarTagueamentoApp({
        ref_figma: '2',
        name: '',
        screen: 'Bottomsheet Refazer Biometria',
        ref_type: 'botao',
        content_action: 'Toque',
        content_name: 'Fechar',
        product: convenioName,

        product_area: 'refin',
      })
    }

    setShowBottomSheetRefazerBiometria(false)
    redirectBiometria()
  }

  const handleRefazerBiometria = () => {
    BridgeService.tic({
      name: 'btn_refazer_biometria',
      action: 'refazer_biometria',
    })

    if (isApp) {
      Tag.enviarTagueamentoApp({
        ref_figma: '2',
        name: '',
        screen: 'Bottomsheet Refazer Biometria',
        ref_type: 'botao',
        content_action: 'Toque',
        content_name: 'Refazer biometria',
        product: convenioName,

        product_area: 'refin',
      })
    }

    setShowBottomSheetRefazerBiometria(false)
    redirectBiometria()
  }

  return (
    <BottomSheet onClose={handleClose} noSwipe>
      <ColorWrapper color={Colors.GRAY500} fontWeight="600" margin="0">
        <TextParagraph variant="headline-h3">Biometria não validada!</TextParagraph>
      </ColorWrapper>

      <ColorWrapper color={Colors.GRAY500} margin="0 0 16px 0">
        <TextParagraph variant="body-3" margin="0 0 16px 0">
          Ocorreu um erro durante a biometria, por favor faça o processo novamente!
        </TextParagraph>
      </ColorWrapper>
      <Button fullWidth onClick={handleRefazerBiometria} style={{ marginTop: '14px' }}>
        Refazer biometria
      </Button>
    </BottomSheet>
  )
}
